import React from 'react';
import { useLazyAgedDebtorsDetailQuery } from "../../../services/headofficeadmin";

const useAgedDebtorsMonthlyFeeDetails = () => {

    
    const [sort, setSort] = React.useState("CreatedDate+desc");
    const [pageLimit, setPageLimit] = React.useState(50);
    //const [pageLimit, setPageLimit] = React.useState(20);
    const [cacheKey, setCacheKey] = React.useState(new Date().valueOf());
    const [isLoadingState, setIsLoadingState] = React.useState(false);

    
    
    const [query, { data, isLoading, isFetching, isError, error, ...loadResults }] = useLazyAgedDebtorsDetailQuery();

    //console.log('hookLoadResults',loadResults);
    //console.log('hookData',data);

    const [archiveMonth, setArchiveMonth] = React.useState();
    const [agedMonth, setAgedMonth] = React.useState();
    const [feeGroupIds, setFeeGroupIds] = React.useState();
    
    //console.log('hook data', data);

    // note: we need to have a default set of data in-case we have an undefined response
    const { pagination, results, newRecordsSinceCache } = data || { pagination: { page: 1, pageSize: pageLimit, totalCount: 0, totalPages: 1 }, results: [], newRecordsSinceCache: 0 };
    //console.log("hook pagination:", pagination);
    //const { page, totalCount, totalPages } = pagination;
    const { page, pageSize, totalCount, totalPages } = pagination;
    const hasMore = totalCount > 0 && page < totalPages;
    const isNextPageLoading = isFetching === true || isLoading === true || isLoadingState === true;

    //const onLoadOptions = (request) => query(request);

    const clear = (request) => {
        //console.log('request in clear' ,request);
        setArchiveMonth(request.archiveMonth);
        setAgedMonth(request.agedMonth);
        setFeeGroupIds(request.feeGroupIds);
        if (isNextPageLoading) {
            return;
        }

        //console.log("details hook pageSize:", pagination);

        const newCacheKey = new Date().valueOf();
        setIsLoadingState(_ => true);
        query({
            cacheKey: newCacheKey,
            archiveMonth: request.archiveMonth,
            agedMonth: request.agedMonth,
            feeGroupIds: request.feeGroupIds,
            limit: pageLimit,
            page: 1,
            sort
        })
        .unwrap()
        .then(
            _ => {
                setCacheKey(_prev => newCacheKey);   
            }
        )
        .finally(setIsLoadingState(_prev => false));
    };
    
    //const isRowLoaded = (index) => !hasMore || index < results.length;
    const isRowLoaded = (index) => results[index] || index < results.length;

    const loadMore = () => {
        //console.log('request in loadMore' ,request);
    //const loadMore = () => {
        // safety check to make sure we don't reload when already loading!
        if (isNextPageLoading) {
            return;
        }
        setIsLoadingState(_ => true);
        query({ 
            cacheKey,
            archiveMonth: archiveMonth,
            agedMonth: agedMonth,
            feeGroupIds: feeGroupIds, 
            limit: pageLimit,
            page: page + 1,
            sort 
        })
        .unwrap()
        .finally(setIsLoadingState(_prev => false));
    };

    const sortTable = (property) => {
        // we want the sort to initially be descending ??
        let newDirection = "";
        let [sortProperty, direction] = sort.split("+");

        // if the current property is already selected, reverse the sort direction
        if (property === sortProperty) {
            newDirection = direction === "DESC" ? null : "+DESC";
        }

        setSort(property + (newDirection ?? ""));
        clear();
    };

    return { 
        ...loadResults,
        clear,
        data: results,
        error,
        isError,
        hasMore,
        isFetching,
        isLoading,
        isNextPageLoading,
        isNewRecords: newRecordsSinceCache > 0,
        isRowLoaded,
        limit: pageLimit,
        loadMore: isNextPageLoading ? () => {} : loadMore, 
        newRecordsSinceCache,
        page,
        pagination,
        sort,
        sortTable,
        totalCount,
        totalPages
    };

};


export default useAgedDebtorsMonthlyFeeDetails;